import React from 'react';
import { Paper, Typography, Button, Divider, Tooltip } from '@material-ui/core';

// One row per connected system.
//
// They do not share a config shape — Albi goes through the provider registry,
// QConnect and Roomvo predate it, and the barcode setting is a scanner input
// format rather than an external service at all. So the row is uniform and each
// Configure opens that system's own settings unchanged; forcing three working
// integrations into one abstraction would be risk without user-visible gain.
const StatusDot = ({ on }) => (
  <span
    style={{
      display: 'inline-block',
      width: 9,
      height: 9,
      borderRadius: '50%',
      marginRight: 10,
      backgroundColor: on ? '#2E7D32' : 'transparent',
      border: `2px solid ${on ? '#2E7D32' : '#9e9e9e'}`,
      verticalAlign: 'middle',
      flex: '0 0 auto',
    }}
  />
);

const IntegrationRow = ({ integration, onConfigure, last }) => (
  <>
    <div style={{ display: 'flex', alignItems: 'center', padding: '14px 4px' }}>
      <StatusDot on={integration.connected} />
      <div style={{ flex: 1, minWidth: 0 }}>
        <Typography variant="body1" style={{ fontWeight: 600 }}>
          {integration.name}
        </Typography>
        <Typography variant="caption" color="textSecondary" style={{ display: 'block' }}>
          {integration.description}
        </Typography>
      </div>
      <div style={{ textAlign: 'right', marginRight: 16, minWidth: 140 }}>
        <Typography variant="caption" style={{ color: integration.connected ? '#2E7D32' : '#9e9e9e' }}>
          {integration.status}
        </Typography>
        {integration.detail ? (
          <Typography variant="caption" color="textSecondary" style={{ display: 'block' }}>
            {integration.detail}
          </Typography>
        ) : undefined}
      </div>
      <Tooltip title={integration.configureHint ?? ''}>
        <span>
          <Button
            size="small"
            variant="outlined"
            id={integration.tourId}
            onClick={() => onConfigure(integration.id)}
            style={{ borderColor: '#4E564E', color: '#4E564E' }}
          >
            Configure
          </Button>
        </span>
      </Tooltip>
    </div>
    {last ? undefined : <Divider />}
  </>
);

const IntegrationsPanel = ({ integrations, onConfigure }) => (
  // No padding on the Paper itself: the header bar runs edge to edge on every
  // other card, and insetting it here left a white border around the dark bar.
  // The padding belongs to the content below it instead.
  <Paper elevation={5}>
    <Typography variant="h4" className="header-text">
      Integrations
    </Typography>
    <div style={{ padding: '0 20px 8px' }}>
      {integrations.map((integration, i) => (
        <IntegrationRow
          key={integration.id}
          integration={integration}
          onConfigure={onConfigure}
          last={i === integrations.length - 1}
        />
      ))}
    </div>
  </Paper>
);

export default IntegrationsPanel;
